import { useState } from 'react';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';
import axios from 'axios';
import '../App.css';
import './LoginPage.css';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { service } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const token = searchParams.get('token');
    if (!token) {
      setError('Invalid reset link. No token provided.');
      return;
    }

    try {
      setIsSubmitting(true);
      const API_URL = process.env.REACT_APP_API_URL || window.location.origin;
      const response = await axios.post(`${API_URL}/api/auth/reset-password`, {
        token,
        newPassword: password
      });

      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate(service ? `/${service}` : `/login`);
        }, 3000);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password. The link may have expired.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="checkout-container-new" style={{minHeight:"100vh",background:"#0f0f0f",display:"flex",flexDirection:"column"}}>
      <header className="login-header" style={{flexShrink:0}}>
        <a href="https://openhosst.com" className="login-logo">
          <img src="/logo-dark.png" alt="OpenHosst" />
        </a>
      </header>

      <div className="email-entry-container">
        <div className="email-entry-card">
          {success ? (
            <>
              <div className="success-icon-animated" style={{marginBottom: '24px'}}>
                <svg className="success-checkmark" viewBox="0 0 52 52">
                  <circle className="success-checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
                  <path className="success-checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
              </div>

              <h1 className="email-entry-title">Password Reset Successful!</h1>
              <p className="email-entry-subtitle" style={{marginBottom: '32px'}}>
                Your password has been changed successfully. Redirecting to login...
              </p>

              <div style={{textAlign: 'center', padding: '20px', background: 'rgba(64, 224, 208, 0.1)', borderRadius: '8px'}}>
                <i className="fa-solid fa-spinner fa-spin" style={{fontSize: '24px', color: '#40E0D0'}}></i>
                <p style={{marginTop: '12px', color: '#cccccc', fontSize: '14px'}}>Please wait...</p>
              </div>
            </>
          ) : (
            <>
              <div className="icon-container" style={{marginBottom: '24px'}}>
                <i className="fa-solid fa-lock-open" style={{fontSize: '48px', color: '#40E0D0'}}></i>
              </div>

              <h1 className="email-entry-title">Create New Password</h1>
              <p className="email-entry-subtitle" style={{marginBottom: '32px'}}>
                Enter your new password below
              </p>

              {error && (
                <div className="alert alert-error" style={{marginBottom: '20px'}}>
                  <i className="fa-solid fa-circle-exclamation"></i> {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group-domain" style={{marginBottom: '20px'}}>
                  <label className="form-label-new" htmlFor="password">New Password</label>
                  <div style={{position: 'relative'}}>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      className="form-input-new"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter new password (min 8 characters)"
                      required
                      disabled={isSubmitting}
                      style={{fontSize: '16px', padding: '14px 16px', paddingRight: '48px'}}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        color: '#40E0D0',
                        cursor: 'pointer',
                        fontSize: '18px',
                        padding: '8px'
                      }}
                    >
                      <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                    </button>
                  </div>
                </div>

                <div className="form-group-domain">
                  <label className="form-label-new" htmlFor="confirmPassword">Confirm New Password</label>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="confirmPassword"
                    className="form-input-new"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                    required
                    disabled={isSubmitting}
                    style={{fontSize: '16px', padding: '14px 16px'}}
                  />
                </div>

                <button
                  type="submit"
                  className="btn-continue"
                  disabled={isSubmitting}
                  style={{marginTop: '24px'}}
                >
                  {isSubmitting ? (
                    <>
                      <i className="fa-solid fa-spinner fa-spin"></i> Resetting...
                    </>
                  ) : (
                    <>
                      Reset Password
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{flexShrink: 0}}>
                        <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </>
                  )}
                </button>
              </form>

              <p className="email-entry-note" style={{marginTop: '24px'}}>
                Remember your password? <button onClick={() => navigate(service ? `/${service}` : `/login`)} className="btn-link" style={{color: '#40E0D0', fontWeight: '600'}}>Back to Login</button>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
